import React from 'react';
import Navigation from '../../Home/Navigation/Navigation';
import bg from '../../Assets/bghero1.png';
import Footer from './../../Home/Footer/Footer';

const AboutMe = () => {
    return (
        <div className="herobg" style={{ background: `url(${bg})`, backgroundAttachment: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
            <Navigation />
            <hr className="text-center text-white w-75 mx-auto" />
            <h1 className="text-white txbg text-center">Hi! I am Kamrun Nahar</h1>
            <p className="text-white txbg mt-3 container" style={{ lineHeight: "170%", maxWidth:"700px", fontSize:"1.1rem"}}>I am a tech enthusiast and MERN Stack Developer. I am working to make a website interactive with good UX and responsive as well.
                I have graduated from the Military Institute of Science and Technology (MIST) in Electrical and Electronics Engineering (EEE). I have worked for many clients as UI/UX designer, and I have some experience in copywriting.
                <br />
                <br />
                Art, design, and science interest me. I love photography.

                Apart from all these, a notable thing about me is, I need oxygen, water, and coffee for my survival.
            </p>
            <Footer />
        </div>
    );
};

export default AboutMe;